import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const overquota256TariffId = 'W256G1m_single_quota_2022_cloud';

// CLOUDWEB-18909
// Зажим на кнопку Скачать в чистилке
const overquotaAbClearDownload: 'a' | 'b' | 'c' | undefined = getFeature('overquota-ab-clear-dwnld');

export const overquotaAbClearDownloadVarBHideDownload = overquotaAbClearDownload === 'b';
export const overquotaAbClearDownloadVarCDisableDownload = overquotaAbClearDownload === 'c';
